import { FC } from 'react';

import styled from '@emotion/styled';

import { Button } from '@britishcouncil/react-solas';
import { Modal } from '@britishcouncil/react-solas-ors3';

export const CandidateDetailsInfoModal: FC<{ onExit: () => void; show: boolean }> = ({ onExit, show }) => {
  return (
    <Modal
      show={show}
      title="Candidate details"
      onExit={onExit}
      footer={
        <Footer>
          <Button intent="primary" onClick={onExit}>
            Ok
          </Button>
        </Footer>
      }
    >
      <Container>
        <p>
          For any changes to the candidate’s personal details, please contact the British Council at ‘contact point
          details’ to discuss these changes
        </p>
      </Container>
    </Modal>
  );
};

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  max-width: 632px;
`;
